function toggleContent() {
  const contentsSection = document.querySelectorAll('.hidden-information');
  const contentsDescription = document.getElementById('featureInformation');
  const buttonSeeMore = document.querySelector('.more-information-block');
  const showMoreLabel = document.getElementById('show-more-label').value;
  const showLessLabel = document.getElementById('show-less-label').value;

  if(contentsDescription.classList.contains("feature-information")) {
    contentsDescription.classList.remove("feature-information")
  } else {
    contentsDescription.classList.add("feature-information")
  }

  const isHidden = contentsSection[0].style.display === 'none' || contentsSection[0].style.display === '';
  
  contentsSection.forEach(content => {
    if (isHidden) {
      content.style.display = 'block';
      buttonSeeMore.setAttribute("data-status", "open");
    } else {
      content.style.display = 'none';
      buttonSeeMore.setAttribute("data-status", "closed");
    }
  });

  if (buttonSeeMore.dataset.status.includes("closed")) {
    buttonSeeMore.textContent = showMoreLabel;
    window.scrollTo({
        top: contentsDescription,
        behavior: 'smooth'
    });
  } else {
    buttonSeeMore.textContent = showLessLabel;
  }
}

document.addEventListener('DOMContentLoaded', function() {
    const contentsDescription = document.getElementById('featureInformation');
    const showMoreLabel = document.getElementById('show-more-label').value;
    const buttonSeeMore = document.querySelector('.more-information-block');

    if (contentsDescription) {
      if (contentsDescription.scrollHeight > 300) {
        contentsDescription.classList.add('feature-information');
        buttonSeeMore.style.display = 'block';
        buttonSeeMore.setAttribute("data-status", "closed");
        buttonSeeMore.textContent = showMoreLabel;
      }
    }
});